module.exports = __webpack_public_path__ + "static/media/globe.9f3ce692.png";